/**
 * O vocabulário das chaves de acesso, do lado do cliente.
 *
 * Mora aqui, e não em cada app, porque as duas superfícies que vendem o mesmo
 * produto têm de contar a mesma história: a landing pública, em `apps/site`, e
 * a oferta de dentro do app. Enquanto a regra viveu só no app, a landing
 * enumerava as sete leis do Enac uma a uma, e o cartão do plano gratuito ao
 * lado ficava com meio metro de vazio no meio.
 */

/** O prefixo da chave de uma Legislação Comentada (D-45). */
export const PREFIXO_DA_LEI = 'commented_law:';

export function ehLei(chave: string): boolean {
  return chave.startsWith(PREFIXO_DA_LEI);
}

/**
 * As leis de um lado, o resto do outro.
 *
 * **Um conjunto de leis é uma coisa, e não seis.** Toda Legislação Comentada
 * entrega o mesmo: o texto aberto e o comentário artigo a artigo. Listada uma a
 * uma, ela repete a mesma frase em cada linha - o Enac abre sete leis, e as
 * telas que as enumeravam gastavam sete blocos para dizer sete vezes a mesma
 * coisa. O que muda de uma para outra é só **qual lei é**, e isso um nome
 * resolve.
 *
 * **E o número de leis cresce sozinho:** cada lei importada vira uma chave num
 * produto, sem ninguém mexer em tela nenhuma. Lista que só cabe enquanto o
 * catálogo for curto quebra de novo sem avisar; uma linha com a contagem cabe
 * sempre.
 *
 * Os módulos ficam em `outros` porque cada um tem resumo próprio e merece a
 * linha que ocupa.
 */
export function separarLeis(chaves: string[]): { leis: string[]; outros: string[] } {
  return {
    leis: chaves.filter(ehLei),
    outros: chaves.filter((chave) => !ehLei(chave)),
  };
}

/**
 * A contagem como se escreve na tela: "7 leis comentadas", "1 lei comentada".
 *
 * A frase sai daqui pelo mesmo motivo que a separação: se cada tela escrever a
 * sua, uma diz "leis comentadas" e a outra "Legislações Comentadas", e o
 * visitante que vê as duas acha que são coisas diferentes.
 */
export function rotuloDasLeis(quantas: number): string {
  return quantas === 1 ? '1 lei comentada' : `${quantas} leis comentadas`;
}
